import React from 'react'
import { Box, Button, Modal, Typography } from '@mui/material'
import { BasicModalWrapper } from '../styled/modal/BasicModal.styled'

interface PlainModalProps {
  open: boolean
  handleClose: () => void
  children: React.ReactNode
  modelWidth?: string
  borderNone?: boolean
  cancelButtonName?: string
  actionButtonName?: string
  onCancel?: () => void
  onAction?: () => void
  title?: string
  actionButtonDisabled?: boolean
}

const PlainModal: React.FC<PlainModalProps> = ({
  open,
  handleClose,
  modelWidth,
  children,
  borderNone = false,
  cancelButtonName,
  actionButtonName,
  onCancel,
  onAction,
  title,
  actionButtonDisabled = false,
}) => {
  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <BasicModalWrapper modelWidth={modelWidth} borderNone={borderNone}>
        {title && (
          <Box mb={2}>
            <Typography variant="h4">{title}</Typography>
          </Box>
        )}
        {children}
        {actionButtonName && (
          <Box display="flex" gap={2} mt={2}>
            {cancelButtonName && (
              <Button
                variant="outlined"
                {...(onCancel && { onClick: onCancel })}
                fullWidth
              >
                {cancelButtonName}
              </Button>
            )}

            <Button
              variant="contained"
              {...(onAction && { onClick: onAction })}
              fullWidth
              disabled={actionButtonDisabled}
            >
              {actionButtonName}
            </Button>
          </Box>
        )}
      </BasicModalWrapper>
    </Modal>
  )
}

export default PlainModal
